import React from 'react';
import { LightBoxUILock } from '../../_flux/components/lightbox_ui_lock/lightbox_ui_lock';
import { hideAction } from '../../_flux/actions/lightbox_ui_lock_actions';
import { LightboxUiLockStore } from '../../_flux/stores/lightbox_ui_lock_store';
import { handleView } from '../handle_view';

const stores = {
    lightBoxUILock: LightboxUiLockStore,
};

function render(
    {
        lightBoxUILock,
    },
    options
) {
    const { visible, loaded } = lightBoxUILock;
    return (
        <LightBoxUILock
            visible={visible}
            loaded={loaded}
            // error={{ ...fsRemoveLightBox }}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);


export const onClose = () => {
    hideAction();
};
